/*
 * @LastEditTime: 2025-02-26 15:44:29
 */
import { buildProps, extend } from '@xzx-design/utils'

import { checkerProps } from '@xzx-design/components/checkbox/src/checker'
import type { ExtractPropTypes } from 'vue'
import type Radio from './radio.tsx'

import type { PropType } from 'vue/dist/vue'
import type { RadioShape } from './types'

export const radioProps = extend(
  {},
  checkerProps,
  buildProps({
    shape: {
      type: String as PropType<RadioShape>,
    },
  })
)

export const radioEmits = {
  'update:modelValue': (value: string) => true,
}

export type RadioProps = ExtractPropTypes<typeof radioProps>
export type RadioInstance = InstanceType<typeof Radio>
export type RadioEmits = typeof radioEmits
